import React from "react"

const SvgTwitter = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="none"
        viewBox="0 0 256 256"
        {...props}
    >
        <g
        fill="none"
        strokeMiterlimit={10}
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        style={{
            mixBlendMode: "normal",
        }}
        textAnchor="none"
        >
        <path
            fill="#000"
            fillRule="nonzero"
            d="M218.667 32 52.955 224H33.147L198.864 32z"
        />
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M166.096 218.667 41.706 37.333h47.771l124.39 181.334z"
        />
        <path
            fill="#000"
            fillRule="nonzero"
            d="m83.861 48 109.75 160h-21.9L61.964 48H83.86m8.427-16H31.584l131.701 192h60.704L92.288 32z"
        />
        </g>
    </svg>
)

export default SvgTwitter
